export enum AvailableSupportTabs {
    OPEN = 'open',
    CLOSED = 'closed',
}
